module.exports = __webpack_public_path__ + "static/media/handheldCardMx.4f707d44.png";